export default __webpack_public_path__ + "paddle_resale1a2c7a.svg";